// code custom js pour fiche produit Tables Added By Ader
document.addEventListener('DOMContentLoaded', function () {
  const infosProduct = document.getElementById('infos_product');
  const imageDimension = document.querySelector('.image_dimension');

  const productInfo = document.querySelector('.product-info');

  // Si l'élément existe et on est sur mobile
  if (infosProduct && productInfo && window.innerWidth <= 768) {
    productInfo.appendChild(infosProduct); // Déplace à la fin
    productInfo.appendChild(imageDimension); // Déplace à la fin
  }
});

